import styled from '@emotion/styled'
import { Box, Button, Card, Grid, TextField, Typography } from '@mui/material'

export const ActionsButtons = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 24px;

  @media (max-width: 440px) {
    margin-left: auto;
  }
`

export const Container = styled(Grid)`
  margin: 0 auto;
  padding: 8px;
`

export const StyledTextField = styled(TextField)`
  width: 100%;
  background-color: #fff;
  & .MuiOutlinedInput-root {
    & fieldset {
      border-color: #e6eaf1 !important;
    }
  }
  & .MuiInputBase-input {
    border: 0;
    box-shadow: none;
  }
`
export const StyledLabel = styled.span`
  color: #323537;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
`
export const StyledTypography = styled(Typography)`
  padding: 0 8px 16px 0;
  color: #323537;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`
export const StyledDetailsContainer = styled(Box)`
  border-radius: 4px;
  border: 1px solid #e6eaf1;
  background: #fff;
  width: 100%;
  flex-shrink: 0;
  padding: 24px;
  margin-top: 16px;
`
export const HTMLContainerBox = styled(Box)`
  display: flex;
  justify-content: center;
  margin: 0 auto;
  border-radius: 8px;
  padding: 0;
`
export const StyledCard = styled(Card)`
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.04);
`
export const DetailsContainerBox = styled(Box)`
  margin: 0 auto;
`
export const ActionButtonsContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
  gap: 16px;
`
export const GreenButton = styled(Button)`
  flex: 1;
  background-color: #5ec269;
  color: white;
  text-transform: capitalize;
`
export const RedButton = styled(Button)`
  flex: 1;
  background-color: #dd524c;
  color: white;
  text-transform: capitalize;
`

export const StyledLabelContainer = styled(Typography)`
  padding: 24px 8px 8px 0;
`
export const StyledCampaignPreviewTitle = styled(Typography)`
  font-size: 20px;
  line-height: 30px;
  letter-spacing: -0.2px;
  margin-bottom: 24px;
`

export const StyledApprovalLink = styled('a')`
  color: #1B51A4;
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  cursor: pointer;
`
